const initStateVendor = {
	page: 1,
	totalPages: 0,
	pageSize: 20,
	orderBy: 'created_at',
	sortBy: 'desc',
	filters: {},
	selectedInputs: [],
	isAdvanceFilterApplied: false,
};

export const advanceFilterReducer = (state = initStateVendor, action) => {
	const { type, payload } = action;
	switch (type) {
		case 'SET_ADVANCE_FILTER':
			return {
				...state,
				page: payload?.page || state.page || 1,
				totalPages: payload?.totalPages || state.totalPages || 0,
				pageSize: payload?.pageSize || state.pageSize || 20,
				orderBy: payload?.orderBy || payload?.order_by || state.orderBy || 'created_at',
				sortBy: payload?.sortBy || payload?.sort_by || state.sortBy || 'desc',
				filters: { ...state.filters, ...payload?.filters } || {},
				isAdvanceFilterApplied:
					payload?.isAdvanceFilterApplied || state.isAdvanceFilterApplied || false,
				selectedInputs: payload?.selectedInputs || state.selectedInputs || [],
			};
		case 'SET_PAGE':
			return {
				...state,
				page: payload.page,
				pageSize: payload.pageSize || 20,
			};
		case 'SET_ADVANCE_FILTER_TOTAL_PAGE':
			return {
				...state,
				totalPages: payload.totalPages,
			};
		case 'SET_SELECTED_INPUT':
			const isAlreadyPresent = state.selectedInputs.some((input) => input.key === payload.key);
			if (isAlreadyPresent) return state;
			return {
				...state,
				selectedInputs: [
					...state.selectedInputs,
					{ key: payload.key, label: payload.label, data: [], value: '' },
				],
			};
		case 'SET_SELECTED_INPUT_VALUE':
			return {
				...state,
				selectedInputs: state.selectedInputs.map((input) => {
					if (input.key === payload.key) {
						return {
							...input,
							value: payload.value,
						};
					}
					return input;
				}),
			};
		case 'SET_SELECTED_INPUT_DATA':
			const updatedData = state.selectedInputs.map((input) => {
				if (input.key === payload.key) {
					return {
						...input,
						data: payload.data,
					};
				}
				return input;
			});
			return {
				...state,
				selectedInputs: updatedData,
			};
		case 'REMOVE_SELECTED_INPUT':
			const updatedFilters = state.selectedInputs.filter((input) => input.key !== payload.key);
			return {
				...state,
				selectedInputs: updatedFilters,
				isAdvanceFilterApplied: updatedFilters.length === 0 ? false : state.isAdvanceFilterApplied,
				filters: updatedFilters?.length === 0 ? {} : state.filters,
				page: updatedFilters.length === 0 ? 1 : state.page,
				pageSize: updatedFilters.length === 0 ? 20 : state.pageSize,
				totalPages: updatedFilters.length === 0 ? 0 : state.totalPages,
			};
		case 'CLEAR_ADVANCE_FILTER':
			return {
				page: 1,
				totalPages: 0,
				pageSize: 20,
				filters: {},
				sortBy: 'desc',
				orderBy: 'created_at',
				selectedInputs: [],
				isAdvanceFilterApplied: false,
			};
		default:
			return state;
	}
};
